module.exports = __webpack_public_path__ + "static/img/__9435.9140c1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9435.jpg
// module id = CTFD
// module chunks = 0